/**
 * Amplify configuration builder. Produces the correct Auth config object depending on the
 * deploy-time authMode (native vs federated).
 */

import type { ResourcesConfig } from "aws-amplify"
import { getConfig, getFederatedConfig } from "../config"
import { logoutBounceUrl } from "./federatedLogout"

/**
 * Build the Amplify ResourcesConfig for the current authMode. Native mode: SRP-based username/email
 * login. Federated mode: OAuth redirect via the configured custom IdP.
 */
export function buildAmplifyConfig(): ResourcesConfig {
  const config = getConfig()

  if (config.authMode === "federated") {
    const federated = getFederatedConfig()
    return {
      Auth: {
        Cognito: {
          userPoolId: config.cognitoUserPoolId,
          userPoolClientId: config.cognitoClientId,
          loginWith: {
            oauth: {
              domain: federated.cognitoDomain,
              scopes: federated.scopes,
              redirectSignIn: [federated.redirectSignIn],
              // Default sign-out target stays /login; the bounce URL is also registered so
              // logout() can select it to route through the IDP's end-session endpoint.
              redirectSignOut: [federated.redirectSignOut, logoutBounceUrl()],
              responseType: "code",
              providers: [{ custom: federated.idpProviderName }],
            },
          },
        },
      },
    }
  }

  return {
    Auth: {
      Cognito: {
        userPoolId: config.cognitoUserPoolId,
        userPoolClientId: config.cognitoClientId,
        loginWith: {
          email: true,
          username: true,
        },
      },
    },
  }
}
